import gql from 'graphql-tag';

export default gql`
  query GetFacility($id: ID!) {
    facility(id: $id) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
      menus
      pdfs
      hyperlinks
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetFacility.ts